<template>
  <div id="dashboard">
    <filters
      :monthRange="true"
      :region="true"
      :markets="true"
      :comparisonYear="true"
      :dataSource="$t('filter.sourceHesta')"
      @refresh="setParams"
    />
    <loading v-if="loading" />
    <b-row v-else>
      <b-col xl="12" md="12">
        <KPICard
          :data="kpiData"
          :chart="kpiChartData"
          :chartEvo="kpiChartEvo"
          @update-kpi="updateKpiChart"
        />
      </b-col>
      <b-col xl="6" md="12">
        <ProvenanceTable :data="provenancesData.provenances" />
      </b-col>
      <b-col xl="6" md="12" v-if="destinationsData">
        <DestinationTable :data="destinationsData" />
      </b-col>
      <b-col xl="6" md="12" v-if="this.starsChart.data[0].data">
        <ChartCard
          :title="$t('dashboard.stars_nights.title')"
          :chartType="this.starsChart.type"
          :options="this.starsChart.options"
          :data="this.starsChart.data"
        />
      </b-col>
      <b-col xl="6" md="12" v-if="regionsData">
        <RegionTable :data="regionsData" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import DashboardMixins from "@/mixins/api/dashboard";
import KPICard from "@/components/dashboard/KPICard";
import ProvenanceTable from "@/components/dashboard/ProvenanceTable";
import DestinationTable from "@/components/dashboard/DestinationTable";
import RegionTable from "@/components/dashboard/RegionTable";
import ChartCard from "@/components/dashboard/ChartCard";
import TableCard from "@/components/dashboard/TableCard";

export default {
  name: "Dashboard",
  mixins: [DashboardMixins],
  components: {
    KPICard,
    ProvenanceTable,
    DestinationTable,
    ChartCard,
    TableCard,
    RegionTable
  },
  methods: {
    setParams(newParams) {
      this.params = newParams;
      this.refreshData();
    },
  },
};
</script>

<style lang="scss">
#dashboard {
  & ::-webkit-scrollbar {
    width: 6px;
  }

  & ::-webkit-scrollbar-track {
    background: theme-color-level("custom", -10);
  }

  & ::-webkit-scrollbar-thumb {
    background: theme-color("custom");
  }

  & ::-webkit-scrollbar-thumb:hover {
    background: theme-color-level("custom", 4);
  }
}
</style>